import authClient from '../../../../api/authClient'

export async function loginRequest({ tenantUsername, identifier, password, rememberDevice }) {
  const payload = {
    tenantUsername,
    email: identifier,
    password,
    rememberMe: Boolean(rememberDevice),
    deviceType: "desktop",
  }

  const { data } = await authClient.post('/auth/login', payload)
  return data
}
